module.exports = __webpack_public_path__ + "img/prevent-0.cb419097.png";